import $ from "jquery";
import md5 from "md5";

let CLIENT_ID = '10000';
let CLIENT_SECRET = 'Z0QUpAXiW8HVCqzeHSEV9TEYFxggM1XpSan0rDux';
import _ from 'lodash'
const localStorageArr = [
  "vuex",
  "project_Id",
  "cdms_userName",
  "cdms_userId",
  "cdms_phone"
];
export const delLocalStorage = () => {
  localStorageArr.forEach(item => {
    localStorage.removeItem(item);
  });
};

/**
 * Cookie操作
 */

export const delCookie = name => {
  let exp = new Date();
  exp.setTime(exp.getTime() - 1);
  let cval = getCookie(name);
  if (cval != null) {
    if (document.URL.indexOf(".yihuayidong.com") > -1 && document.URL.indexOf("test") <0) {
      document.cookie =
        name +
        "=" +
        cval +
        ";expires=" +
        exp.toGMTString() +
        ";domain=.yihuayidong.com";
    } else {
      document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
    }
  }
};

export const setCookie = (name, value, time, path, domain, secure) => {
  let cookieText = encodeURIComponent(name) + "=" + encodeURIComponent(value);
  if (time) {
    let exp = new Date();
    exp.setTime(exp.getTime() + time * 1000);
    cookieText += "; expires=" + exp.toGMTString();
  }
  if (path) {
    cookieText += "; path=" + path;
  }
  if (document.URL.indexOf(".yihuayidong.com") > -1) {
    cookieText += "; domain=" + (domain || ".yihuayidong.com");
  }
  if (secure) {
    cookieText += "; secure";
  }
  document.cookie = cookieText;
};

export const _setCookie = (name, value, time, path, domain, secure) => {
  let cookieText = encodeURIComponent(name) + "=" + encodeURIComponent(value);
  if (time) {
    let exp = new Date();
    exp.setTime(exp.getTime() + time * 1000);
    cookieText += "; expires=" + exp.toGMTString();
  }
  if (path) {
    cookieText += "; path=" + path;
  }
  if (domain) {
    cookieText += "; domain=" + domain;
  }
  if (secure) {
    cookieText += "; secure";
  }
  document.cookie = cookieText;
};

export const getCookie = name => {
  let arrCookie = document.cookie.split("; ");
  for (let i = 0; i < arrCookie.length; i++) {
    let cookieItem = arrCookie[i].split("=");
    if (cookieItem[0] == name) {
      return cookieItem[1];
    }
  }
  return undefined;
};

export const getNoceStr = no_cache => {
  if (no_cache) return Math.ceil(Math.random() * 1000 + 100000);

  let run_count = localStorage.getItem("run_count") || 1;
  localStorage.setItem("run_count", parseInt(run_count) + 1);
  if (run_count == 3) localStorage.setItem("run_count", 1);

  let noce_str = "";
  if (run_count == 2 || run_count == 3) {
    noce_str = localStorage.getItem("noce_str");
  } else {
    noce_str = Math.ceil(Math.random() * 1000 + 100000);
    localStorage.setItem("noce_str", noce_str);
  }
  return noce_str;
};

export const getFiSign = (data, noce_str) => {
  if (!noce_str) noce_str = getNoceStr();
  let keyArr = [];
  data = data ? data : {};
  let dataMerge = Object.assign(data, {
    authorization: getFiAccessToken(),
    client_id: CLIENT_ID,
    app_source: "web",
    nonce: getNoceStr()
  });
  for (let k in dataMerge) {
    if (dataMerge[k] === undefined || k === "sign") {
      continue;
    }
    if (dataMerge[k] === null) {
      dataMerge[k] = "";
    }
    keyArr.push(k);
  }
  keyArr=_.sortBy(keyArr)
  // keyArr = keyArr.sort(function(a, b) {
  //   return a.localeCompare(b);
  // });
  let str = "";
  for (let i in keyArr) {
    str += keyArr[i] + urlencode(dataMerge[keyArr[i]]);
  }
  delete data.authorization;
  // localStorage.setItem('CLIENT_SECRET',JSON.stringify(keyArr) );
  return md5(CLIENT_SECRET + str + CLIENT_SECRET).toUpperCase();
};

export const urlencode = str => {
  str = (str + "").toString();
  return encodeURIComponent(str)
    .replace(/!/g, "%21")
    .replace(/'/g, "%27")
    .replace(/\(/g, "%28")
    .replace(/\)/g, "%29")
    .replace(/\*/g, "%2A")
    .replace(/%20/g, "+")
    .replace(/~/g, "%7E");
};
/**
 * 获取token
 */
export const getFiAccessToken = () => {
  if (getCookie("mhs_access_token")) return getCookie("mhs_access_token");
  let tempAccessToken = "";
  $.ajax({
    url: process.env.VUE_APP_BASE_URL + "/oauth/token",
    type: "POST",
    async: false,
    data: {
      grant_type: "client_credentials",
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET
    },
    dataType: "json",
    success(data) {
      tempAccessToken = data.access_token;
    }
  });
  if (tempAccessToken) {
    _setCookie("mhs_access_token", tempAccessToken, 7200);
  }
  return tempAccessToken;
};

/**
 * 存储localStorage
 */
export const setStore = (name, content) => {
  if (!name) return;
  if (typeof content !== "string") {
    content = JSON.stringify(content);
  }
  window.localStorage.setItem(name, content);
};

/**
 * 获取localStorage
 */
export const getStore = name => {
  if (!name) return;
  let value = window.localStorage.getItem(name);
  if (value !== null) {
    try {
      value = JSON.parse(value);
    } catch (e) {
      value = value;
    }
  }
  return value;
};

/**
 * 删除localStorage
 */
export const removeStore = name => {
  if (!name) return;
  window.localStorage.removeItem(name);
};

/**
 * @param {date} 标准时间格式:Fri Nov 17 2017 09:26:23 GMT+0800 (中国标准时间)
 * @param {type} 类型
 *   type == 1 ---> "yyyy-mm-dd hh:MM:ss.fff"
 *   type == 2 ---> "yyyymmddhhMMss"
 *   type == '' ---> "yyyy-mm-dd hh:MM:ss"
 *   type 为数值类型或者date,datetime,time
 */
export const formatDate = (date, type) => {
  if (type == "date" || type == "datetime") {
    let date = new Date(date);
  }
  let year = date.getFullYear(); //年
  let month =
    date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1; //月
  let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate(); //日
  let hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours(); //时
  let minutes =
    date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes(); //分
  let seconds =
    date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds(); //秒
  let milliseconds =
    date.getMilliseconds() < 10
      ? "0" + date.getMilliseconds()
      : date.getMilliseconds(); //毫秒

  if (type == 1) {
    return (
      year +
      "-" +
      month +
      "-" +
      day +
      " " +
      hour +
      ":" +
      minutes +
      ":" +
      seconds +
      "." +
      milliseconds
    );
  } else if (type == 2) {
    return (
      year + "" + month + "" + day + "" + hour + "" + minutes + "" + seconds
    );
  } else if (type == 3 || type == "date") {
    return year + "-" + month + "-" + day;
  } else if (type == 4 || type == "datetime") {
    return (
      year +
      "-" +
      month +
      "-" +
      day +
      " " +
      hour +
      ":" +
      minutes +
      ":" +
      seconds
    );
  } else if (type == 6) {
    //时分
    return hour + ":" + minutes + ":00";
  } else if (type == 7) {
    //时
    return hour + ":00:00";
  } else if (type == 8) {
    //年月
    return year + "-" + month + "-01" + " " + "00:00:00";
  } else if (type == 9) {
    //年
    return year + "-01-01" + " " + "00:00:00";
  } else {
    if (!isNaN(type) && typeof type === "number") {
      return hour + ":" + minutes + ":" + seconds;
    } else {
      return date;
    }
  }
};

/**
 * 判断空值
 */
export const isEmpty = keys => {
  if (typeof keys === "string") {
    keys = keys.replace(/\"|&nbsp;|\\/g, "").replace(/(^\s*)|(\s*$)/g, "");
    if (keys == "" || keys == null || keys == "null" || keys === "undefined") {
      return true;
    } else {
      return false;
    }
  } else if (typeof keys === "undefined") {
    // 未定义
    return true;
  } else if (typeof keys === "number") {
    return false;
  } else if (typeof keys === "boolean") {
    return false;
  } else if (typeof keys == "object") {
    if (JSON.stringify(keys) == "{}") {
      return true;
    } else if (keys == null) {
      // null
      return true;
    } else {
      return false;
    }
  }

  if (keys instanceof Array && keys.length == 0) {
    // 数组
    return true;
  }
};

export const param2Obj = url => {
  const search = url.split("?")[1];
  if (!search) {
    return {};
  }
  return JSON.parse(
    '{"' +
      decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"') +
      '"}'
  );
};

export const getUrlParam = name => {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
  var r = window.location.search.substr(1).match(reg); //匹配目标参数
  if (r != null) return unescape(r[2]); return null; //返回参数值
}

// 函数防抖
export function debounce(fn, wait) {
  let timeout = null;
  wait = wait || 600;
  return function () {
    let that = this;
    if(timeout !== null)   clearTimeout(timeout);  
    timeout = setTimeout(() => {
      fn.apply(that);
    }, wait);
  }
}

export function uuid(){
  let i, random;
  let uuid = '';
  for (i = 0; i < 32; i++) {
    random = Math.random() * 16 | 0;
    if (i === 8 || i === 12 || i === 16 || i === 20) {
      uuid += '-';
    }
    uuid += (i === 12 ? 4 : (i === 16 ? (random & 3 | 8) : random)).toString(16);
  }
  return uuid;
}